module.exports = __webpack_public_path__ + "img/row-srp-preview-kia.b6db9e40.png";